import { AbstractApi, ApiBaseResponse } from '../../../common/api'
import { DuLabel } from '../types/du-label.types'

class DuLabelApi extends AbstractApi {
  protected url = '/workflows/du-label'

  public async getLabels(): Promise<ApiBaseResponse<DuLabel[]>> {
    const { data: response } = await this.get<ApiBaseResponse<DuLabel[]>>(this.url)

    return response
  }

  public async createLabel(label: Omit<DuLabel, 'id'>): Promise<ApiBaseResponse<DuLabel>> {
    const { data: response } = await this.post<ApiBaseResponse<DuLabel>>(this.url, label)

    return response
  }

  public async updateLabel(id: number, label: Omit<DuLabel, 'id'>): Promise<ApiBaseResponse<DuLabel>> {
    const { data: response } = await this.patch<ApiBaseResponse<DuLabel>>(this.url.concat(`/${id}`), label)

    return response
  }

  public async deleteLabel(id: number): Promise<number> {
    const { status: status } = await this.delete<ApiBaseResponse<void>>(this.url.concat(`/${id}`))

    return status
  }
}

export const duLabelApi = new DuLabelApi()
